import React from "react";

const legacy = localStorage.getItem("legacy") === "true" ? true : false;
// const apiUrl = legacy ? "http://localhost:8081": "http://localhost:8080";
const apiUrl = legacy? "https://rh-helpdesk-server.rhodesislandpass.com": "http://localhost:8080";

export default apiUrl;
    